/**
 * A function to create a log object for the 'viewPreIntroScreen' event (evid: 534)
 *
 * Event description: User visits the screen between signup and start intro.
 * The purpose of this screen is to help acquisition to segment users who cannot track due to new cookies policies.
 *
 * @param {viewPreIntroScreenParams} params - The parameters for this event
 * @property {string} screenName - screen name
 * @return {LogObject<viewPreIntroScreenParams>} LogObject<viewPreIntroScreenParams>
 */
export function viewPreIntroScreen(params) {
    return { evid: 534, src: 2, endpoint: 'mfi', params: params };
}
/**
 * A function to create a log object for the 'startIntro' event (evid: 554)
 *
 * Event description: An event that fires when the user starts the Wix/editorX intro
 *
 * @param {startIntroParams} params - The parameters for this event
 * @property {string} flow - which flow the user start
 * @return {LogObject<startIntroParams>} LogObject<startIntroParams>
 */
export function startIntro(params) {
    return { evid: 554, src: 2, endpoint: 'mfi', params: params };
}
/**
 * A function to create a log object for the 'topFunnelStartFlow' event (evid: 500)
 *
 * Event description: Top Funnel - Start Flow
 *
 * @param {topFunnelStartFlowParams} params - The parameters for this event
 * @property {string} screenVersion - screen_version
 * @property {string} referralInfo - referral_info
 * @property {string} screenName - screen_name
 * @property {number} pageIndex - page_index
 * @property {string} refferalUrl - refferal_url
 * @property {string} pageId - page_id
 * @property {string} flow - flow
 * @property {string} subFlow - sub_flow
 * @property {string} previousScreenVersion - previous_screen_version
 * @property {string} flowTheme - original, light, dark
 * @return {LogObject<topFunnelStartFlowParams>} LogObject<topFunnelStartFlowParams>
 */
export function topFunnelStartFlow(params) {
    return { evid: 500, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'topFunnelScreenView' event (evid: 501)
 *
 * Event description: main funnel intro - screen view
 *
 * @param {topFunnelScreenViewParams} params - The parameters for this event
 * @property {boolean} isFallback - is_fallback
 * @property {string} user_msid - user_msid
 * @property {string} introGuid - intro_guid
 * @property {string} browser_language - browser_language
 * @property {string} referral_name - referral_name
 * @property {string} screen_version - screen_version
 * @property {string} initial_data - initial_data
 * @property {string} screenName - screen_name
 * @property {string} widget_name - widget_name
 * @property {string} additional_info - additional_info
 * @property {number} pageIndex - page_index
 * @property {string} screenResolution - screen_resolution
 * @property {string} pageId - page_id
 * @property {string} previousScreen - previous_screen
 * @property {string} userInfo - user_info
 * @property {string} error - error
 * @property {string} intro_type - intro_type
 * @property {string} flow - flow
 * @property {string} question_name - question_name
 * @property {string} introVariant - intro_variant
 * @property {string} split_screen_type - split_screen_type
 * @property {string} platform - platform
 * @property {string} resolved_language - resolved_language
 * @property {string} subFlow - sub_flow
 * @property {string} previousScreenVersion - previous_screen_version
 * @return {LogObject<topFunnelScreenViewParams>} LogObject<topFunnelScreenViewParams>
 */
export function topFunnelScreenView(params) {
    return { evid: 501, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroWelcomeScreenClickOnOk' event (evid: 502)
 *
 * Event description: main funnel intro - welcome screen click on “ok”
 *
 * @param {mainFunnelIntroWelcomeScreenClickOnOkParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} flow - flow
 * @return {LogObject<mainFunnelIntroWelcomeScreenClickOnOkParams>} LogObject<mainFunnelIntroWelcomeScreenClickOnOkParams>
 */
export function mainFunnelIntroWelcomeScreenClickOnOk(params) {
    return { evid: 502, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroClickOnSkip' event (evid: 503)
 *
 * Event description: main funnel intro - click on “skip”
 *
 * @param {mainFunnelIntroClickOnSkipParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} flow - flow
 * @return {LogObject<mainFunnelIntroClickOnSkipParams>} LogObject<mainFunnelIntroClickOnSkipParams>
 */
export function mainFunnelIntroClickOnSkip(params) {
    return { evid: 503, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroDropdownOpen' event (evid: 504)
 *
 * Event description: main funnel intro - dropdown open
 *
 * @param {mainFunnelIntroDropdownOpenParams} params - The parameters for this event
 * @property {string} screenName - screen_name
 * @property {string} dropdownName - dropdown_name
 * @property {string} trigger - trigger
 * @return {LogObject<mainFunnelIntroDropdownOpenParams>} LogObject<mainFunnelIntroDropdownOpenParams>
 */
export function mainFunnelIntroDropdownOpen(params) {
    return { evid: 504, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroSiteForSelected' event (evid: 505)
 *
 * Event description: main funnel intro - “site for” selected
 *
 * @param {mainFunnelIntroSiteForSelectedParams} params - The parameters for this event
 * @property {string} siteFor - site_for
 * @return {LogObject<mainFunnelIntroSiteForSelectedParams>} LogObject<mainFunnelIntroSiteForSelectedParams>
 */
export function mainFunnelIntroSiteForSelected(params) {
    return { evid: 505, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroCategorySelected' event (evid: 506)
 *
 * Event description: main funnel intro - category selected
 *
 * @param {mainFunnelIntroCategorySelectedParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} industryId - industry_id
 * @property {string} segment - segment
 * @property {string} subcat - subcat
 * @property {string} userInfo - user_info
 * @property {string} category - category
 * @return {LogObject<mainFunnelIntroCategorySelectedParams>} LogObject<mainFunnelIntroCategorySelectedParams>
 */
export function mainFunnelIntroCategorySelected(params) {
    return { evid: 506, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroIntroFinish' event (evid: 507)
 *
 * Event description: main funnel intro - intro finish. happens either automatically when user answered all questions and is redirected to the split screen, or when users clicks on "see recommendation" button (when it's displayed).
 *
 * @param {mainFunnelIntroIntroFinishParams} params - The parameters for this event
 * @property {boolean} profDesigner - prof_designer
 * @property {string} structureId - structure_id
 * @property {string} companySize - company_size
 * @property {boolean} agencyWebDesign - agency_web_design
 * @property {string} industryId - industry_id
 * @property {boolean} agencyWebDevelopment - agency_web_development
 * @property {boolean} agencySEO - agency_seo
 * @property {string} siteFor - site_for
 * @property {string} subcat - subcat
 * @property {boolean} profMarketer - prof_marketer
 * @property {string} userInfo - user_info
 * @property {string} experience - experience
 * @property {boolean} agencyMarketing - agency_marketing
 * @property {boolean} agencyFullService - agency_full_service
 * @property {string} category - category
 * @property {boolean} agencyBranding - agency_branding
 * @property {string} introVariant - intro_variant
 * @property {boolean} agencyOther - agency_other
 * @property {boolean} profOther - prof_other
 * @property {boolean} profDeveloper - prof_developer
 * @property {string} workAt - work_at
 * @property {string} trigger - trigger
 * @return {LogObject<mainFunnelIntroIntroFinishParams>} LogObject<mainFunnelIntroIntroFinishParams>
 */
export function mainFunnelIntroIntroFinish(params) {
    return { evid: 507, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroExpertTypeDropdownClick' event (evid: 508)
 *
 * Event description: main intro funnel - expert type dropdown click (for users that chose "site for a client")
 *
 * @param {mainFunnelIntroExpertTypeDropdownClickParams} params - The parameters for this event
 * @property {string} expertType - expert_type
 * @return {LogObject<mainFunnelIntroExpertTypeDropdownClickParams>} LogObject<mainFunnelIntroExpertTypeDropdownClickParams>
 */
export function mainFunnelIntroExpertTypeDropdownClick(params) {
    return { evid: 508, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroExpertTypeSelected' event (evid: 509)
 *
 * Event description: main intro funnel - expert type dropdown selection. user - when user clicks on “done”, or automatic if users clicks elsewhere and his selection was saved.
 *
 * @param {mainFunnelIntroExpertTypeSelectedParams} params - The parameters for this event
 * @property {string} expertType - expert_type
 * @property {string} trigger - trigger
 * @return {LogObject<mainFunnelIntroExpertTypeSelectedParams>} LogObject<mainFunnelIntroExpertTypeSelectedParams>
 */
export function mainFunnelIntroExpertTypeSelected(params) {
    return { evid: 509, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroNonExpertExperienceSelected' event (evid: 510)
 *
 * Event description: main funnel intro - non expert (users that chose "site for myself") dropdown selection of experience
 *
 * @param {mainFunnelIntroNonExpertExperienceSelectedParams} params - The parameters for this event
 * @property {string} nonExpertExperience - non_expert_experience
 * @property {string} screenName - screen_name
 * @return {LogObject<mainFunnelIntroNonExpertExperienceSelectedParams>} LogObject<mainFunnelIntroNonExpertExperienceSelectedParams>
 */
export function mainFunnelIntroNonExpertExperienceSelected(params) {
    return { evid: 510, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroFullStoryStartSession' event (evid: 511)
 *
 * Event description: main funnel intro - FullStory start session
 *
 * @param {mainFunnelIntroFullStoryStartSessionParams} params - The parameters for this event
 * @property {Url} fullstoryurl - fullstoryurl
 * @return {LogObject<mainFunnelIntroFullStoryStartSessionParams>} LogObject<mainFunnelIntroFullStoryStartSessionParams>
 */
export function mainFunnelIntroFullStoryStartSession(params) {
    return { evid: 511, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'topFunnelUserTyping' event (evid: 512)
 *
 * Event description: main funnel intro - category selection - user typing
 *
 * @param {topFunnelUserTypingParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {number} returnedResults - returned_results
 * @property {string} text - text
 * @property {string} flow - flow
 * @property {string} platform - platform
 * @return {LogObject<topFunnelUserTypingParams>} LogObject<topFunnelUserTypingParams>
 */
export function topFunnelUserTyping(params) {
    return { evid: 512, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroCompanySizeSelected' event (evid: 513)
 *
 * Event description: main funnel intro - company size selected
 *
 * @param {mainFunnelIntroCompanySizeSelectedParams} params - The parameters for this event
 * @property {string} companySize - company_size
 * @return {LogObject<mainFunnelIntroCompanySizeSelectedParams>} LogObject<mainFunnelIntroCompanySizeSelectedParams>
 */
export function mainFunnelIntroCompanySizeSelected(params) {
    return { evid: 513, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroWorkAtSelected' event (evid: 514)
 *
 * Event description: main funnel intro - "work at" selection (for users who chose "site for a client")
 *
 * @param {mainFunnelIntroWorkAtSelectedParams} params - The parameters for this event
 * @property {string} workAt - work_at
 * @return {LogObject<mainFunnelIntroWorkAtSelectedParams>} LogObject<mainFunnelIntroWorkAtSelectedParams>
 */
export function mainFunnelIntroWorkAtSelected(params) {
    return { evid: 514, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroAgencyTypeDropdownClick' event (evid: 515)
 *
 * Event description: main funnel intro - agency type dropdown click (for users who chose "site for a client" and "work at agency..")
 *
 * @param {mainFunnelIntroAgencyTypeDropdownClickParams} params - The parameters for this event
 * @property {string} agencyType - agency_type
 * @return {LogObject<mainFunnelIntroAgencyTypeDropdownClickParams>} LogObject<mainFunnelIntroAgencyTypeDropdownClickParams>
 */
export function mainFunnelIntroAgencyTypeDropdownClick(params) {
    return { evid: 515, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroAgencyTypeSelected' event (evid: 516)
 *
 * Event description: main funnel intro - agency type dropdown click (for users who chose "site for a client" and "work at agency..")
 *
 * @param {mainFunnelIntroAgencyTypeSelectedParams} params - The parameters for this event
 * @property {string} screenName - screen_name
 * @property {string} agencyType - agency_type
 * @property {string} trigger - trigger
 * @return {LogObject<mainFunnelIntroAgencyTypeSelectedParams>} LogObject<mainFunnelIntroAgencyTypeSelectedParams>
 */
export function mainFunnelIntroAgencyTypeSelected(params) {
    return { evid: 516, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroClickOnProgressBar' event (evid: 517)
 *
 * Event description: main funnel intro - click on one of the steps in intro's progress bar.
 *
 * @param {mainFunnelIntroClickOnProgressBarParams} params - The parameters for this event
 * @property {string} screenName - screen_name
 * @property {number} originStep - origin_step
 * @property {string} destinationScreen - destination_screen
 * @property {number} destinationStep - destination_step
 * @return {LogObject<mainFunnelIntroClickOnProgressBarParams>} LogObject<mainFunnelIntroClickOnProgressBarParams>
 */
export function mainFunnelIntroClickOnProgressBar(params) {
    return { evid: 517, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroHoverOn' event (evid: 518)
 *
 * Event description: main funnel intro - users hover on a button
 *
 * @param {mainFunnelIntroHoverOnParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} hoverButton - hover_button
 * @property {string} screenName - screen_name
 * @property {number} hoverTime - hover_time
 * @property {string} flow - flow
 * @return {LogObject<mainFunnelIntroHoverOnParams>} LogObject<mainFunnelIntroHoverOnParams>
 */
export function mainFunnelIntroHoverOn(params) {
    return { evid: 518, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroClickBack' event (evid: 519)
 *
 * Event description: main funnel intro - click back to previous step
 *
 * @param {mainFunnelIntroClickBackParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {number} originStep - origin_step
 * @property {string} destinationScreen - destination_screen
 * @property {string} flow - flow
 * @property {number} destinationStep - destination_step
 * @return {LogObject<mainFunnelIntroClickBackParams>} LogObject<mainFunnelIntroClickBackParams>
 */
export function mainFunnelIntroClickBack(params) {
    return { evid: 519, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroSkillSetSelected' event (evid: 520)
 *
 * Event description: main intro funnel - skill set selection - for users with high experience that chose "someone else"  (fires when user clicks “done"/"next”)
 *
 * @param {mainFunnelIntroSkillSetSelectedParams} params - The parameters for this event
 * @property {string} skill - skill
 * @return {LogObject<mainFunnelIntroSkillSetSelectedParams>} LogObject<mainFunnelIntroSkillSetSelectedParams>
 */
export function mainFunnelIntroSkillSetSelected(params) {
    return { evid: 520, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroCompanyRoleSelected' event (evid: 521)
 *
 * Event description: main funnel intro - users selected their role in the company (for users who chose "site for a company")
 *
 * @param {mainFunnelIntroCompanyRoleSelectedParams} params - The parameters for this event
 * @property {string} companyRole - comapny_role
 * @return {LogObject<mainFunnelIntroCompanyRoleSelectedParams>} LogObject<mainFunnelIntroCompanyRoleSelectedParams>
 */
export function mainFunnelIntroCompanyRoleSelected(params) {
    return { evid: 521, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'topFunnelClickAnAnswer' event (evid: 522)
 *
 * Event description: main funnel intro - answer button click (before clicking next)
 *
 * @param {topFunnelClickAnAnswerParams} params - The parameters for this event
 * @property {boolean} suggested_option - suggested_option
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} button_name - button_name
 * @property {DateTime} scheduledTime - scheduled_time
 * @property {number} pageIndex - page_index
 * @property {string} pageId - page_id
 * @property {string} previousScreen - previous_screen
 * @property {string} flow - flow
 * @property {string} question_name - question_name
 * @property {string} answer - answer
 * @property {number} position - position
 * @property {string} platform - platform
 * @property {string} subFlow - sub_flow
 * @property {string} previousScreenVersion - previous_screen_version
 * @property {string} free_text - free_text
 * @property {boolean} final_answer - final_answer
 * @return {LogObject<topFunnelClickAnAnswerParams>} LogObject<topFunnelClickAnAnswerParams>
 */
export function topFunnelClickAnAnswer(params) {
    return { evid: 522, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroAgencyFormClickSubmit' event (evid: 523)
 *
 * Event description: main funnel intro - user clicked submit in agency form (not necessarily passed validation and moved to next page)
 *
 * @param {mainFunnelIntroAgencyFormClickSubmitParams} params - The parameters for this event
 * @property {string} companyWebsite - company_website
 * @property {string} sitesBuilt - sites_built
 * @property {string} agencyRole - agency_role
 * @return {LogObject<mainFunnelIntroAgencyFormClickSubmitParams>} LogObject<mainFunnelIntroAgencyFormClickSubmitParams>
 */
export function mainFunnelIntroAgencyFormClickSubmit(params) {
    return { evid: 523, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroAgencyThankYouPageClick' event (evid: 524)
 *
 * Event description: main funnel intro - click on "get started" in thank you page (after agency form submitted properly)
 *
 * @param {mainFunnelIntroAgencyThankYouPageClickParams} params - The parameters for this event
 * @return {LogObject<mainFunnelIntroAgencyThankYouPageClickParams>} LogObject<mainFunnelIntroAgencyThankYouPageClickParams>
 */
export function mainFunnelIntroAgencyThankYouPageClick(params) {
    return { evid: 524, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroSubCategorySelected' event (evid: 525)
 *
 * Event description: sub-category selected in main funnel intro
 *
 * @param {mainFunnelIntroSubCategorySelectedParams} params - The parameters for this event
 * @property {string} structureId - structure_id
 * @property {string} screenName - screen_name
 * @property {string} industryId - industry_id
 * @property {string} subcat - subcat
 * @property {string} userInfo - user_info
 * @property {string} category - category
 * @return {LogObject<mainFunnelIntroSubCategorySelectedParams>} LogObject<mainFunnelIntroSubCategorySelectedParams>
 */
export function mainFunnelIntroSubCategorySelected(params) {
    return { evid: 525, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroSendFormToDb' event (evid: 526)
 *
 * Event description: main funnel intro - fired when form information is being sent to external database and indicates its success
 *
 * @param {mainFunnelIntroSendFormToDbParams} params - The parameters for this event
 * @property {boolean} isCompleted - is_completed
 * @property {string} screenName - screen_name
 * @property {string} appName - app_name
 * @property {string} info - info
 * @return {LogObject<mainFunnelIntroSendFormToDbParams>} LogObject<mainFunnelIntroSendFormToDbParams>
 */
export function mainFunnelIntroSendFormToDb(params) {
    return { evid: 526, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'topFunnelScreenAnswer' event (evid: 527)
 *
 * Event description: main intro funnel - multiple answers - users answered a question with multiple answers  (fires when user clicks done/next/submit)
 *
 * @param {topFunnelScreenAnswerParams} params - The parameters for this event
 * @property {string} subflow - sub_flow
 * @property {string} user_msid - user_msid
 * @property {string} screen_version - screen_version
 * @property {string} initial_data - initial_data
 * @property {string} screenName - screen_name
 * @property {string} payload - payload
 * @property {string} additional_info - additional_info
 * @property {number} pageIndex - page_index
 * @property {string} answer_type - answer_type
 * @property {string} pageId - page_id
 * @property {string} previousScreen - previous_screen
 * @property {string} error - error
 * @property {string} flow - flow
 * @property {string} question_name - question_name
 * @property {string} answer - answer
 * @property {number} position - position
 * @property {string} platform - platform
 * @property {string} previousScreenVersion - previous_screen_version
 * @property {string} action - action
 * @property {string} free_text - free_text
 * @return {LogObject<topFunnelScreenAnswerParams>} LogObject<topFunnelScreenAnswerParams>
 */
export function topFunnelScreenAnswer(params) {
    return { evid: 527, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroStoresCallBooked' event (evid: 528)
 *
 * Event description: main funnel intro - user filled out all the information in the form (book a call with a stores expert) and clicked "book call"
 *
 * @param {mainFunnelIntroStoresCallBookedParams} params - The parameters for this event
 * @property {DateTime} scheduledTime - scheduled_time
 * @property {string} agentEmail - agent_email
 * @return {LogObject<mainFunnelIntroStoresCallBookedParams>} LogObject<mainFunnelIntroStoresCallBookedParams>
 */
export function mainFunnelIntroStoresCallBooked(params) {
    return { evid: 528, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroSubflowAssigned' event (evid: 529)
 *
 * Event description: fires when user gets into a subflow in the wix intro. For example, bookings flow.
 *
 * @param {mainFunnelIntroSubflowAssignedParams} params - The parameters for this event
 * @property {string} subflow - subflow
 * @return {LogObject<mainFunnelIntroSubflowAssignedParams>} LogObject<mainFunnelIntroSubflowAssignedParams>
 */
export function mainFunnelIntroSubflowAssigned(params) {
    return { evid: 529, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroFinishSubflow' event (evid: 530)
 *
 * Event description: every time users finishes a subflow in the intro. For example: booking subflow, stores subflow, etc.
 *
 * @param {mainFunnelIntroFinishSubflowParams} params - The parameters for this event
 * @property {string} userInfo - user_info
 * @property {string} subflow - subflow
 * @return {LogObject<mainFunnelIntroFinishSubflowParams>} LogObject<mainFunnelIntroFinishSubflowParams>
 */
export function mainFunnelIntroFinishSubflow(params) {
    return { evid: 530, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroElegibleForSubflowevent' event (evid: 531)
 *
 * Event description: users is elegible for having a subflow.
 * if its a test then A wont get the new subflow but they are actually elegible.
 * Its helping us to create exposure in wixer.
 *
 * @param {mainFunnelIntroElegibleForSubfloweventParams} params - The parameters for this event
 * @property {string} subflow - subflow
 * @return {LogObject<mainFunnelIntroElegibleForSubfloweventParams>} LogObject<mainFunnelIntroElegibleForSubfloweventParams>
 */
export function mainFunnelIntroElegibleForSubflowevent(params) {
    return { evid: 531, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'bookingsExploreAndAppointments' event (evid: 532)
 *
 * Event description: Users who choose exploring in the bookings flow and then selected that they need the feature of appointments online.
 *
 * @param {bookingsExploreAndAppointmentsParams} params - The parameters for this event
 * @return {LogObject<bookingsExploreAndAppointmentsParams>} LogObject<bookingsExploreAndAppointmentsParams>
 */
export function bookingsExploreAndAppointments(params) {
    return { evid: 532, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'mainFunnelIntroAppSuggestionNavigationClick' event (evid: 533)
 *
 * Event description: Event fires when the user clicks either skip or next in the app suggestion screen.
 * It show us which apps remained checked and what was the status of the app when the page was rendered.
 *
 * @param {mainFunnelIntroAppSuggestionNavigationClickParams} params - The parameters for this event
 * @property {string} hotels - hotels
 * @property {string} structureId - structure_id
 * @property {string} food_orders - food_orders
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} music - music
 * @property {string} restaurant_menus - restaurant_menus
 * @property {string} table_reservations - table_reservations
 * @property {string} groups - groups
 * @property {string} chat - chat
 * @property {string} subcat - subcat
 * @property {string} stores - stores
 * @property {string} art_store - art_store
 * @property {string} photo_albums - photo_albums
 * @property {string} blog - blog
 * @property {string} subscribe_form - subscribe_form
 * @property {string} video - video
 * @property {string} flow - flow
 * @property {string} forum - forum
 * @property {string} forms - forms
 * @property {string} category - category
 * @property {string} nextView - next_view
 * @property {string} navButton - nav_button
 * @property {string} instagram_feed - instagram_feed
 * @property {string} pricing_plans - pricing_plans
 * @property {string} online_scheduling - online_scheduling
 * @property {string} challenges - challenges
 * @property {string} events - events
 * @property {string} bandsintown - bandsintown
 * @return {LogObject<mainFunnelIntroAppSuggestionNavigationClickParams>} LogObject<mainFunnelIntroAppSuggestionNavigationClickParams>
 */
export function mainFunnelIntroAppSuggestionNavigationClick(params) {
    return { evid: 533, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'clickForAClientInWelcomePage' event (evid: 536)
 *
 * Event description: Users clicks for a client cta in the partners welcome page.
 *
 * @param {clickForAClientInWelcomePageParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} flow - flow
 * @return {LogObject<clickForAClientInWelcomePageParams>} LogObject<clickForAClientInWelcomePageParams>
 */
export function clickForAClientInWelcomePage(params) {
    return { evid: 536, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'fitnessMainScreenAnswered' event (evid: 537)
 *
 * Event description: event fires when clicking next in the work screen.
 * It records all the answers giving in that page.
 *
 * @param {fitnessMainScreenAnsweredParams} params - The parameters for this event
 * @property {string} services_offered_answer - services_chosen
 * @property {boolean} clientele_trainers - clientele_trainers
 * @property {boolean} members_gyms - members_gyms
 * @property {string} screenName - screen_name
 * @property {boolean} services_offered - services_offered
 * @property {string} clientele_members_answer - clientele_members_answer
 * @property {boolean} services_how - services_how
 * @property {string} services_how_answer - services_how_answer
 * @property {boolean} multiple_locations - multiple_locations
 * @return {LogObject<fitnessMainScreenAnsweredParams>} LogObject<fitnessMainScreenAnsweredParams>
 */
export function fitnessMainScreenAnswered(params) {
    return { evid: 537, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'typedTextInIntro' event (evid: 538)
 *
 * Event description: Users types an answer in one of the wix intro screens
 *
 * @param {typedTextInIntroParams} params - The parameters for this event
 * @property {string} text - text
 * @property {string} screenName - screen_name
 * @return {LogObject<typedTextInIntroParams>} LogObject<typedTextInIntroParams>
 */
export function typedTextInIntro(params) {
    return { evid: 538, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'clickSuggestedOption' event (evid: 540)
 *
 * Event description: an event that fired for each click on the suggested option in the category screen
 *
 * @param {clickSuggestedOptionParams} params - The parameters for this event
 * @property {string} button_name - button_name
 * @property {string} screenName - screen_name
 * @return {LogObject<clickSuggestedOptionParams>} LogObject<clickSuggestedOptionParams>
 */
export function clickSuggestedOption(params) {
    return { evid: 540, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'clickNeedHelp' event (evid: 541)
 *
 * Event description: fire when the user clicks on the need help button on each screen in the intro
 *
 * @param {clickNeedHelpParams} params - The parameters for this event
 * @property {string} screenName - screen_name
 * @return {LogObject<clickNeedHelpParams>} LogObject<clickNeedHelpParams>
 */
export function clickNeedHelp(params) {
    return { evid: 541, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'topFunnelGeneralAction' event (evid: 542)
 *
 * Event description: general action on the intro
 *
 * @param {topFunnelGeneralActionParams} params - The parameters for this event
 * @property {string} user_msid - user_msid
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} payload - payload
 * @property {number} pageIndex - page_index
 * @property {string} targetScreen - target_screen
 * @property {string} pageId - page_id
 * @property {string} previousScreen - previous_screen
 * @property {string} error - error
 * @property {string} flow - flow
 * @property {string} question_name - question_name
 * @property {string} platform - platform
 * @property {string} subFlow - sub_flow
 * @property {string} value - value
 * @property {string} previousScreenVersion - previous_screen_version
 * @property {string} action - action
 * @return {LogObject<topFunnelGeneralActionParams>} LogObject<topFunnelGeneralActionParams>
 */
export function topFunnelGeneralAction(params) {
    return { evid: 542, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'topFunnelAppsSelected' event (evid: 550)
 *
 * Event description: Top Funnel - Apps Selected
 *
 * @param {topFunnelAppsSelectedParams} params - The parameters for this event
 * @property {string} app_id_prompt - app_id_prompt
 * @property {string} app_id_hardcoded - app_id_hardcoded
 * @property {string} built_in_app_id - built_in_app_id
 * @property {string} uuid - uuid
 * @property {string} flow - flow
 * @property {string} app_name - app_name
 * @property {string} app_id - app_id
 * @property {GUID} msid - msid
 * @property {string} action - action
 * @return {LogObject<topFunnelAppsSelectedParams>} LogObject<topFunnelAppsSelectedParams>
 */
export function topFunnelAppsSelected(params) {
    return { evid: 550, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'topFunnelFinishFlow' event (evid: 599)
 *
 * Event description: Top Funnel - Finish Flow
 *
 * @param {topFunnelFinishFlowParams} params - The parameters for this event
 * @property {string} screenVersion - screen_version
 * @property {string} structureId - structure_id
 * @property {string} screenName - screen_name
 * @property {string} target_url - target_url
 * @property {string} industryId - industry_id
 * @property {string} businessType - business_type
 * @property {number} pageIndex - page_index
 * @property {string} pageId - page_id
 * @property {string} previousScreen - previous_screen
 * @property {string} flow - flow
 * @property {string} subIndustry - sub_industry
 * @property {string} businessTerm - business_term
 * @property {string} answer - answer
 * @property {string} category - category
 * @property {string} subFlow - sub_flow
 * @property {string} previousScreenVersion - previous_screen_version
 * @property {string} mainIndustry - main_industry
 * @property {boolean} isPotentialPartner - is_potential_partner
 * @return {LogObject<topFunnelFinishFlowParams>} LogObject<topFunnelFinishFlowParams>
 */
export function topFunnelFinishFlow(params) {
    return { evid: 599, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'secondSiteIntroScreenView' event (evid: 600)
 *
 * Event description: second site intro - screen view
 *
 * @param {secondSiteIntroScreenViewParams} params - The parameters for this event
 * @property {string} screenName - screen_name
 * @property {string} userInfo - user_info
 * @return {LogObject<secondSiteIntroScreenViewParams>} LogObject<secondSiteIntroScreenViewParams>
 */
export function secondSiteIntroScreenView(params) {
    return { evid: 600, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'secondSiteIntroClickOnSkip' event (evid: 601)
 *
 * Event description: second site intro - click on "skip"
 *
 * @param {secondSiteIntroClickOnSkipParams} params - The parameters for this event
 * @property {string} screenName - screen_name
 * @return {LogObject<secondSiteIntroClickOnSkipParams>} LogObject<secondSiteIntroClickOnSkipParams>
 */
export function secondSiteIntroClickOnSkip(params) {
    return { evid: 601, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'secondSiteIntroDropdownOpen' event (evid: 602)
 *
 * Event description: main funnel intro - dropdown open
 *
 * @param {secondSiteIntroDropdownOpenParams} params - The parameters for this event
 * @property {string} screenName - screen_name
 * @property {string} dropdownName - dropdown_name
 * @property {string} trigger - trigger
 * @return {LogObject<secondSiteIntroDropdownOpenParams>} LogObject<secondSiteIntroDropdownOpenParams>
 */
export function secondSiteIntroDropdownOpen(params) {
    return { evid: 602, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'secondSiteIntroCategorySelected' event (evid: 603)
 *
 * Event description: second site intro - category selected
 *
 * @param {secondSiteIntroCategorySelectedParams} params - The parameters for this event
 * @property {string} category - category
 * @return {LogObject<secondSiteIntroCategorySelectedParams>} LogObject<secondSiteIntroCategorySelectedParams>
 */
export function secondSiteIntroCategorySelected(params) {
    return { evid: 603, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'secondSiteIntroAdiEditorSelected' event (evid: 604)
 *
 * Event description: second site intro - adi/editor selected
 *
 * @param {secondSiteIntroAdiEditorSelectedParams} params - The parameters for this event
 * @property {string} platform - platform
 * @return {LogObject<secondSiteIntroAdiEditorSelectedParams>} LogObject<secondSiteIntroAdiEditorSelectedParams>
 */
export function secondSiteIntroAdiEditorSelected(params) {
    return { evid: 604, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'secondSiteIntroFinish' event (evid: 605)
 *
 * Event description: second site intro - finish.
 * platform is null (question was not displayed) if category was non-ADI.
 *
 * @param {secondSiteIntroFinishParams} params - The parameters for this event
 * @property {string} category - category
 * @property {string} platform - platform
 * @property {string} trigger - trigger
 * @return {LogObject<secondSiteIntroFinishParams>} LogObject<secondSiteIntroFinishParams>
 */
export function secondSiteIntroFinish(params) {
    return { evid: 605, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'secondSiteIntroFullStoryStartSession' event (evid: 650)
 *
 * Event description: second site intro - FullStory start session
 *
 * @param {secondSiteIntroFullStoryStartSessionParams} params - The parameters for this event
 * @property {Url} fullstoryurl - fullstoryurl
 * @return {LogObject<secondSiteIntroFullStoryStartSessionParams>} LogObject<secondSiteIntroFullStoryStartSessionParams>
 */
export function secondSiteIntroFullStoryStartSession(params) {
    return { evid: 650, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'aiAssistantSiteProfileView' event (evid: 700)
 *
 * Event description: AI Assistant - Business Profile View
 *
 * @param {aiAssistantSiteProfileViewParams} params - The parameters for this event
 * @property {string} screenVersion - screen_version
 * @property {string} screenName - screen_name
 * @property {string} pageId - page_id
 * @property {string} flow - flow
 * @return {LogObject<aiAssistantSiteProfileViewParams>} LogObject<aiAssistantSiteProfileViewParams>
 */
export function aiAssistantSiteProfileView(params) {
    return { evid: 700, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'aiAssistantContentShownOnSiteProfile' event (evid: 701)
 *
 * Event description: AI Assistant - Content Shown on Business Profile
 *
 * @param {aiAssistantContentShownOnSiteProfileParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {boolean} is_displayed - is_displayed
 * @property {string} screenName - screen_name
 * @property {string} modifyed_by - modifyed_by
 * @property {string} objectType - object_type
 * @property {string} flow - flow
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @property {number} order_index - order_index
 * @return {LogObject<aiAssistantContentShownOnSiteProfileParams>} LogObject<aiAssistantContentShownOnSiteProfileParams>
 */
export function aiAssistantContentShownOnSiteProfile(params) {
    return { evid: 701, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'aiAssistantClickOnEditInSiteProfile' event (evid: 702)
 *
 * Event description: AI Assistant - Click on Edit
 *
 * @param {aiAssistantClickOnEditInSiteProfileParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} objectType - object_type
 * @property {string} flow - flow
 * @property {string} currentValue - current_value
 * @property {GUID} msid - msid
 * @property {number} order_index - order_index
 * @return {LogObject<aiAssistantClickOnEditInSiteProfileParams>} LogObject<aiAssistantClickOnEditInSiteProfileParams>
 */
export function aiAssistantClickOnEditInSiteProfile(params) {
    return { evid: 702, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'aiAssistantEditClicksInSiteProfile' event (evid: 703)
 *
 * Event description: AI Assistant - Edit Clicks in Business Profile
 *
 * @param {aiAssistantEditClicksInSiteProfileParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} clickType - click_type
 * @property {string} objectType - object_type
 * @property {string} flow - flow
 * @property {GUID} msid - msid
 * @property {string} value - value
 * @property {number} order_index - order_index
 * @return {LogObject<aiAssistantEditClicksInSiteProfileParams>} LogObject<aiAssistantEditClicksInSiteProfileParams>
 */
export function aiAssistantEditClicksInSiteProfile(params) {
    return { evid: 703, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'aiAssistantHoverInSiteProfile' event (evid: 704)
 *
 * Event description: AI Assistant - Hover in Site Profile
 *
 * @param {aiAssistantHoverInSiteProfileParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} hover_type - hover_type
 * @property {number} hoverTime - hover_time
 * @property {string} objectType - object_type
 * @property {string} flow - flow
 * @property {string} currentValue - current_value
 * @property {GUID} msid - msid
 * @property {number} order_index - order_index
 * @return {LogObject<aiAssistantHoverInSiteProfileParams>} LogObject<aiAssistantHoverInSiteProfileParams>
 */
export function aiAssistantHoverInSiteProfile(params) {
    return { evid: 704, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'aiAssistantChatContentView' event (evid: 710)
 *
 * Event description: User saw content in AI Assistant Chat
 *
 * @param {aiAssistantChatContentViewParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} provider - provider
 * @property {string} screenName - screen_name
 * @property {string} contentSection - content_section
 * @property {string} contentVersion - content_version
 * @property {string} contentType - content_type
 * @property {string} keepers - keepers
 * @property {string} flow - flow
 * @property {string} content - content
 * @property {GUID} msid - msid
 * @property {number} order_index - order_index
 * @return {LogObject<aiAssistantChatContentViewParams>} LogObject<aiAssistantChatContentViewParams>
 */
export function aiAssistantChatContentView(params) {
    return { evid: 710, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'aiAssistantActionInTypingConsole' event (evid: 711)
 *
 * Event description: General actions the user did in the AI Assistant chat
 *
 * @param {aiAssistantActionInTypingConsoleParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {boolean} clicked_send - clicked_send
 * @property {string} flow - flow
 * @property {GUID} msid - msid
 * @property {string} questionContent - question_content
 * @property {string} value - value
 * @property {string} action - action
 * @return {LogObject<aiAssistantActionInTypingConsoleParams>} LogObject<aiAssistantActionInTypingConsoleParams>
 */
export function aiAssistantActionInTypingConsole(params) {
    return { evid: 711, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'aiAssistantGeneralClicksInChatContent' event (evid: 712)
 *
 * Event description: Any click within the content.
 * For example: clicks on widgets
 *
 * @param {aiAssistantGeneralClicksInChatContentParams} params - The parameters for this event
 * @property {string} screenVersion - screen_version
 * @property {string} screenName - screen_name
 * @property {boolean} isAnswer - is_answer
 * @property {string} contentSection - content_section
 * @property {string} contentVersion - content_version
 * @property {string} contentType - content_type
 * @property {string} flow - flow
 * @property {string} content - content
 * @property {number} orderIndex - order_index
 * @property {string} answer - answer
 * @property {string} buttonName - button_name
 * @property {GUID} msid - msid
 * @return {LogObject<aiAssistantGeneralClicksInChatContentParams>} LogObject<aiAssistantGeneralClicksInChatContentParams>
 */
export function aiAssistantGeneralClicksInChatContent(params) {
    return { evid: 712, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'aiAssistantAssetShownOnDashboard' event (evid: 730)
 *
 * Event description: AI Assistant - Asset Shown On Dashboard
 *
 * @param {aiAssistantAssetShownOnDashboardParams} params - The parameters for this event
 * @property {string} asset_id - asset_id
 * @property {string} section - section
 * @property {GUID} msid - msid
 * @return {LogObject<aiAssistantAssetShownOnDashboardParams>} LogObject<aiAssistantAssetShownOnDashboardParams>
 */
export function aiAssistantAssetShownOnDashboard(params) {
    return { evid: 730, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'aiAssistantClickInDashboardAsset' event (evid: 731)
 *
 * Event description: AI Assistant - Clicks in Dashboard
 *
 * @param {aiAssistantClickInDashboardAssetParams} params - The parameters for this event
 * @property {string} asset_id - asset_id
 * @property {string} button_name - button_name
 * @return {LogObject<aiAssistantClickInDashboardAssetParams>} LogObject<aiAssistantClickInDashboardAssetParams>
 */
export function aiAssistantClickInDashboardAsset(params) {
    return { evid: 731, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'aiAssistantScrollActionInChat' event (evid: 732)
 *
 * Event description: Scroll in Chat (for Chat on Mobile).
 * Only "meaningful" scrolls - i.e. till the next Chat Item (answer) is fully visible.
 *
 * @param {aiAssistantScrollActionInChatParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} flow - flow
 * @property {string} targetValue - target_value
 * @property {GUID} msid - msid
 * @property {string} action - action
 * @return {LogObject<aiAssistantScrollActionInChatParams>} LogObject<aiAssistantScrollActionInChatParams>
 */
export function aiAssistantScrollActionInChat(params) {
    return { evid: 732, src: 2, endpoint: '', params: params };
}
/**
 * A function to create a log object for the 'aiAssistantSwipeActionInChat' event (evid: 733)
 *
 * Event description: Swipe in Chat (for Chat on Mobile).
 * Only "meaningful" swipes - i.e. till the next Button is fully visible.
 *
 * @param {aiAssistantSwipeActionInChatParams} params - The parameters for this event
 * @property {string} screen_version - screen_version
 * @property {string} screenName - screen_name
 * @property {string} flow - flow
 * @property {string} targetValue - target_value
 * @property {GUID} msid - msid
 * @property {string} action - action
 * @return {LogObject<aiAssistantSwipeActionInChatParams>} LogObject<aiAssistantSwipeActionInChatParams>
 */
export function aiAssistantSwipeActionInChat(params) {
    return { evid: 733, src: 2, endpoint: '', params: params };
}
//# sourceMappingURL=index.js.map